import { AbstractControl, ValidatorFn } from '@angular/forms';

export default class ValidatorUtils {
  static dateRangeValidator(toControlName: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: string } | null => {
      if (!control.parent) {
        return null;
      }

      const rangeStartControl = control;
      const rangeEndControl = control.parent.get(toControlName);

      if (!rangeEndControl) {
        return null;
      }

      const start = rangeStartControl.value
        ? new Date(rangeStartControl.value)
        : rangeStartControl.value;
      const end = rangeEndControl.value
        ? new Date(rangeEndControl.value)
        : rangeEndControl.value;

      if (start && end && start > end) {
        return {
          'Validation.RangeEndError': 'Range end is before range start',
        };
      }

      return null;
    };
  }

  static dateTimeRangeEndValidator(fromControlName: string): ValidatorFn {
    return (
      control: AbstractControl
    ): { [key: string]: AbstractControl } | null => {
      if (!control.parent) {
        return null;
      }

      const rangeStartControl = control.parent.get(fromControlName);
      if (!rangeStartControl) {
        return null;
      }
      if (control.dirty) {
        rangeStartControl.markAsDirty({ onlySelf: true });
        rangeStartControl.updateValueAndValidity({ onlySelf: true });
      }

      return null;
    };
  }

  static lowerThanOtherControlValidator(formControlName: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: string } | null => {
      if (!control.parent) return null;

      const lowerControl = control;
      const higherControl = control.parent.get(formControlName);

      if (!higherControl) {
        return null;
      }

      if (lowerControl.value > higherControl.value) {
        return {
          lowerThanOtherControlValidator: `Value can not be higher than ${higherControl.value}`,
        };
      }

      return null;
    };
  }

  static noWhitespaceValidator(control: AbstractControl): ValidatorFn | null {
    if (typeof control.value === 'number') return null;
    return ((control.value || '').trim().length
      ? null
      : { whiteSpace: true }) as unknown as ValidatorFn;
  }

  static timeRangeValidator(toControlName: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: string } | null => {
      if (!control.parent) {
        return null;
      }

      const rangeStartControl = control;
      const rangeEndControl = control.parent.get(toControlName);

      if (
        !rangeEndControl ||
        (!rangeEndControl.value && !rangeStartControl.value)
      ) {
        return null;
      }

      const start: string = `${rangeStartControl.value}`;
      const end: string = `${rangeEndControl.value}`;

      if (start && end && start >= end) {
        return {
          timeRangeAndNotEqualError:
            'Range end is before or equal to range start',
        };
      }

      return null;
    };
  }
}
